import { Link } from "react-router-dom";
import {  Headset } from "lucide-react";
import ScrollArea from 'react-scrollbar'

import { controllerHub } from "../../../services/controllers/hub";
import { useMerchant } from "../../../store/global/useMerchant";
import { useEffect } from "react";
import { useSupport } from "../../../store/global/useSupport";
import { Ticket } from "./ticket";
import { Empty } from "./empty";

export function Support() {
  const CLHub = controllerHub()
  const storeId = useMerchant(st => st.data.merchant.id)
  const tickets = useSupport(st => st.data.tickets)

  useEffect(() => {
    if (storeId) CLHub.getTickets(storeId)
  }, [storeId])


  return (
    <div className="w-full rounded-lg border-zinc-200/30 shadow-md border p-4 gap-4 flex flex-col sm:col-span-2 sm:row-span-7  md:col-span-2 md:row-span-6 lg:col-span-3 lg:row-span-5 xl:col-span-2 xl:row-span-6 bg-white">
      <div className="w-full flex">
        <Link to="/suporte" className="flex gap-2 text-scale-500 font-semibold text-lg items-center">
          <Headset /> Suporte
        </Link>
      </div>
      {!tickets.length && <Empty /> }
      {!!tickets.length  && (
        <ScrollArea smoothScrolling horizontal={false} className="w-full h-full" >
          <div className="w-full flex flex-col gap-1 pb-1 pr-2.5">
            {tickets.map((ticket) => <Ticket data={ticket} /> )}
          </div>
        </ScrollArea>
      )}
    </div>
  );
}
